/* eslint-disable max-len */
import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        width: 'auto' as 'auto',
        padding: '0 .5rem',
        border: 'none' as const
    },
    dateRangeInput: {
        width: '196px',
        display: 'flex',
        flexFlow: 'row nowrap'
    },
    dateInput: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#CFCFCF'}`,
        borderRadius: '3px',
        boxSizing: 'border-box',
        outline: 'none' as const,
        padding: '0.2rem .1rem .1rem .3rem',
        fontSize: '.7rem',
        fontWeight: 'bold' as const,
        lineHeight: '1rem',
        color: '#484848',
        width: '84px',
        height: '1.7rem',
        cursor: 'pointer',
        backgroundColor: theme?.app?.applicationColors.enumColors.white || '#FFFFFF'
    },
    dateInputFocused: {
        padding: '.2rem .1rem 0 .3rem',
        borderBottom: `2px solid ${theme?.app?.clientTheme.colors.primaryColor || '#375073'}`
    },
    dateRangeArrow: { width: '20px' },
    arrowSvg: {
        verticalAlign: 'middle',
        fill: '#484848',
        height: '24px'
    },
    popper: {
        border: '1px solid rgba(0,0,0,0.1)',
        borderRadius: '3px',
        padding: '14px 18px 22px 18px',
        backgroundColor: theme?.app?.applicationColors.enumColors.white || '#FFFFFF'
    },
    popperArrow: {
        position: 'absolute',
        top: -8,
        width: 16,
        height: 6,
        '&::before': {
            borderRight: 'none' as const,
            borderBottom: 'none' as const,
            border: '1px solid rgba(0,0,0,0.1)',
            content: '""',
            position: 'absolute' as const,
            width: 15,
            height: 15,
            backgroundColor: theme?.app?.applicationColors.enumColors.white || '#FFFFFF',
            transform: 'rotate(45deg)',
            top: -1
        }
    },
    arrowStartDate: { '&::before': { left: '0px' }},
    arrowEndDate: { '&::before': { left: '112px' }},
    applyButton: {
        height: '1.7rem',
        marginLeft: '.3rem',
        fontSize: '.8rem'
    }
}));